import { AuditTrailReportReducerDispatch, AuditTrailReportReduxState, AuditTrailReportReduxTypes } from "./types";

const CREATE_AUDIT_TRAIL_REPORT_INIT_STATE: AuditTrailReportReduxState = {
  data: null,
  loading: false,
  error: null
};

const CreateAuditTrailReportReducer = (
  state: AuditTrailReportReduxState = CREATE_AUDIT_TRAIL_REPORT_INIT_STATE,
  action: AuditTrailReportReducerDispatch
) => {
  switch (action.type) {
    case AuditTrailReportReduxTypes.AUDIT_TRAIL_REPORT:
      return {
        ...state,
        error: null,
        loading: true
      };

    case AuditTrailReportReduxTypes.AUDIT_TRAIL_REPORT_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        loading: false
      };

    case AuditTrailReportReduxTypes.AUDIT_TRAIL_REPORT_ERROR:
      return {
        ...state,
        data: null,
        error: action.payload.error,
        loading: false
      };

    case AuditTrailReportReduxTypes.RESET_AUDIT_TRAIL_REPORT:
      return {
        ...state,
        data: null,
        error: null,
        loading: false
      };

    default:
      return { ...state };
  }
};

export { CreateAuditTrailReportReducer };
